<rx-select
	[id]="id"
	[label]="'OrderSection.Type' | translate"
	[formControl]="procedureTypeControl"
	[options]="procedureTypes$ | async"
	[isRequired]="true"
	[isDisabled]="isProcedureAndTypeReadOnly$ | async"
	name="procedureTypeControl"
	panelClass="rx-object-options-panel-8"
>
</rx-select>
